<template>
  <div>
    <div class="mb-8" v-if="externalVacancy">
      <b>Эта вакансия на {{ integration.name }}</b>
      <div v-if="!edit">
        {{ externalVacancy.externalTitle }} (id: {{ externalVacancy.externalId }})
        <a class="icon-href" :href="externalLink">
          <VIcon color="blue" small>
            mdi-open-in-new
          </VIcon>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Integration from '@/orm/models/Integration/Integration';
import { computed } from '@vue/composition-api';

export default {
  name: 'IntegrationsVacancyItem',
  props: {
    externalVacancy: {
      type: Object,
      default: () => null,
    },
    integration: {
      type: Object,
      required: true,
    },
    vacancyId: {
      type: Number,
      required: true,
    },
    edit: Boolean,
  },
  setup({ externalVacancy }) {
    const externalLink = computed(() => {
      return `https://www.rabota.ru/vacancy/${externalVacancy.externalId}`;
    });

    return {
      integrations: computed(() => Integration.all()),
      externalLink,
    };
  },
};
</script>

<style lang="scss" scoped>
  .icon-href {
    text-decoration: none;
  }
</style>

<i18n lang="yml" locale="en">

</i18n>
<i18n lang="yml" locale="ru">
  h1: Импорт откликов
  title: Интеграция с Job-сайтами
  edit: Редактировать
  thisVacancy: Эта вакансия на
</i18n>
